module.exports = function() {
  return new Worker(__webpack_public_path__ + "305497eb407dd9ed9c6a.worker.js");
};